import React from "react"
import styles from "@/components/Remedy/components/TextInfoBlock2/TextInfoBlock2.module.scss"
import { Box, Grid, Typography } from "@kohler-dsm-library/kohler-core"

export const TextInfoBlock2 = ({ title, description }) => {
  return (
    <Box
      id="pxp-text-info-block-2"
      component="section"
      mod="charcoal"
      className={styles["text-info-block-2"]}
    >
      <Grid rowGap={20}>
        <div className={styles["__title-column"]}>
          <Typography component="span" size="h3">
            {title}
          </Typography>
        </div>
        <div className={styles["__description-column"]}>
          <Typography component="span" size="paragraph-large">
            {description}
          </Typography>
        </div>
      </Grid>
    </Box>
  )
}
